module.exports = __webpack_public_path__ + "img/de_flag.ccbf1c70.svg";